import {Component, OnInit, ViewChild} from "@angular/core";
import {Constants} from '../../../../util/Constants';
import {AnonymousService} from '../../../../services/anonymous-service';
import {ActivatedRoute, Router} from '@angular/router';
import {SharedService} from '../../../../services/shared-service/shared.service';
import {UserService} from '../../../../services/users-service/user-service';
import {ErrorService} from "../../../../util/error_service/error.service";
import {MdSlider} from "@angular/material";
import {User} from "../../../../services/users-service/user.model";

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss']
})
export class UserProfileComponent implements OnInit {
  pageTitle = 'Create User';

  public userData: any;
  public superAgentId: number;
  public userId: number;
  public isBlocked: any;
  public one = 'one';
  public two = 'two';
  public three = 'three';
  public four = 'four';
  public isSuper: boolean;
  public selectedMenu: String;
@ViewChild('slider') slider: MdSlider;

  constructor(public _sharedService: SharedService, public router: Router, public anonymousService: AnonymousService,
              public agentService: UserService, public activatedRoute: ActivatedRoute, public error: ErrorService ) {
    this.activatedRoute.params.subscribe(params => {
      this.userId = +params['id'];
    });
    this.selectedMenu = _sharedService.menuNo;

    this.getUser();
  }


  ngOnInit() {}


  toggleBlockUser() {
    if (!this.userData.blocked) {
      this.blockUser();
    } else {
      this.unBlockUser();
    }
  }

  toggleApiUserStatus() {
    this.agentService.configureUserStatus(this.userId, !this.userData.isApiUser).subscribe(
      data => {
        this.getUser();
      },
      err => {
        const errMsg = this.error.errorHandlerWithText(this.toggleApiUserStatus, err);
      }
    )
  }



  // block user
  blockUser() {
    const userId = this.userId;
    this.agentService.blockUser(this.userId).subscribe(
      data => {
        this.getUser();
      },
      err => {
        // console.log(err);
        const errMsg = this.error.errorHandlerWithText(this.blockUser, err);
        // console.log(errMsg.message);
      }
    )
  }

// Unblock user
  unBlockUser() {
    const userId = this.userId;
    this.agentService.unblockUser(this.userId).subscribe(
      data => {
        this.getUser();
      },
      err => {
        const errMsg = this.error.errorHandlerWithText(this.unBlockUser, err);
        // console.log(errMsg.message);
      }
    )
  }

  public getUser() {
    this.anonymousService.getUser(this.userId).subscribe(
      data => {
        this.userData = new User(data.data[0]);
        console.log('%', this.userData);
      },
      err => {
        const errMsg = this.error.errorHandlerWithText(this.getUser, err);
        // console.log(errMsg.message);
      }
    )
  }

  //
  // viewProfile() {
  //   this.selectedMenu = 'two';
  //   this.router.navigate(['admin/agent/' +  this.userId + '/view-profile/']);
  // }
  //
  // viewAgents() {
  //   this.selectedMenu = 'three';
  //   this.router.navigate(['admin/agent/' +  this.userId + '/user-agents/']);
  // }
  //
  // userPermission() {
  //   this.selectedMenu = 'four';
  //   this.router.navigate(['admin/agent/' +  this.userId + '/permissions/']);
  // }

}



// WEBPACK FOOTER //
// ./src/app/Dashboard/DashboardPages/User management/user-page/user-profile.component.ts